import { type FunctionComponent } from "react";
import type { ConversationMessageApiModel as ChatMessage } from "@noa/api-core";
import { createReferenceMap } from "@noa/api-client";
import { ChatMessageReference } from "./chat-message-reference";

interface ChatMessageReferencesProps {
  references?: Map<number, string[]>;
  chatMessage: ChatMessage;
}

export const ChatMessageReferences: FunctionComponent<ChatMessageReferencesProps> = ({ references, chatMessage }) => {
  if (!references?.size || !chatMessage.used_sources.length) return null;

  const referenceMap = createReferenceMap({ references, chatMessage });

  return (
    <>
      {Array.from(references.entries())
        .sort(([a], [b]) => a - b)
        .map(([refNumber, refIds]) => (
          <ChatMessageReference key={refNumber} refNumber={refNumber} refIds={refIds} referenceMap={referenceMap} />
        ))}
    </>
  );
};
